import { render, staticRenderFns } from "./CardStatusSchedule.vue?vue&type=template&id=205a166a&scoped=true&"
import script from "./CardStatusSchedule.vue?vue&type=script&lang=js&"
export * from "./CardStatusSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CardStatusSchedule.vue?vue&type=style&index=0&id=205a166a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a166a",
  null
  
)

export default component.exports